import { PGET } from 'helpers/api'

// Guruhlangan tovarlar ro'yxatlarda (nomenklatura, qabul qilish, qayta narxlash,
// hisobotlar ...) faqat "bosh" tovar sifatida ko'rinadi -- guruh a'zolari alohida
// qator bo'lib chiqmaydi. Shuning uchun a'zoning (bola) shtrix-kodi bo'yicha qidiruv
// bo'sh natija qaytaradi.
//
// Bu yerda bola shtrix-kodidan bosh tovar shtrix-kodini topamiz: qidiruv o'sha kod
// bilan qayta yuboriladi va foydalanuvchi tovarni topadi.

const parentBarcodeCache = new Map()

export function looksLikeBarcode(value) {
	return /^\d{6,}$/.test(String(value ?? '').trim())
}

// Guruhlar ro'yxati bo'yicha qidirish.
async function fromGroupList(posId, barcode) {
	const response = await PGET(
		`/services/web/api/product-group-pageList/${posId}`,
		{ search: barcode, size: 20 }
	)
	const rows = response?.data || []
	// Qidirilgan kod bosh tovarniki bo'lsa -- almashtirishning hojati yo'q.
	const hit = rows.find((row) => row?.productGroupBarcode && String(row.productGroupBarcode) !== barcode)
	return hit ? String(hit.productGroupBarcode) : null
}

// Mahsulot qo'shish qidiruvi: guruhlangan a'zo so'ralganda bosh tovarni qaytaradi.
async function fromProductHelper(posId, barcode) {
	const response = await PGET(
		'/services/web/api/product-in-helper',
		{ name: barcode, posId: posId, barcode: true }
	)
	const rows = response?.data || []
	const hit = rows.find((row) => row?.barcode && String(row.barcode) !== barcode)
	return hit ? String(hit.barcode) : null
}

// Bola shtrix-kodi -> bosh tovar shtrix-kodi. Topilmasa (yoki matn shtrix kod
// bo'lmasa) null qaytadi -- bunda qidiruv odatdagidek davom etadi.
export async function findGroupParentBarcode(posId, value) {
	const barcode = String(value ?? '').trim()
	if (!posId || !looksLikeBarcode(barcode)) return null

	const key = `${posId}:${barcode}`
	if (parentBarcodeCache.has(key)) return parentBarcodeCache.get(key)

	let parentBarcode = null
	try {
		parentBarcode = (await fromGroupList(posId, barcode)) || (await fromProductHelper(posId, barcode))
	} catch (error) {
		parentBarcode = null
	}

	parentBarcodeCache.set(key, parentBarcode)
	return parentBarcode
}
